import {Component, Input} from '@angular/core';

/**
 * Component for showing one row of the invest table
 */
@Component({
  selector: 'app-sanierung-invest-row',
  templateUrl: './sanierung-invest-row.component.html'
})
export class SanierungInvestRowComponent {
  /**
   * name of the invest
   */
  @Input() name: string

  /**
   * type of the invest, something like primary|secondary
   */
  @Input() type: string

  /**
   * The amount to be shown
   */
  @Input() amount: number;

  /**
   * should the amount be highlighted
   */
  @Input() amountHighlight: boolean = false;

  /**
   * should a help message bei visible
   */
  @Input() hasHelp: boolean = false;

  /**
   * textkeyprefix for all texts
   */
  @Input() textkeyPrefix: string = 'moderat.sanierung.invest.';

  /**
   * placeholders for the (help) texts
   */
  @Input() placeholder: any = {};

  /**
   * toggle for the helptext
   */
  showHelp: boolean = false;
}
